<template lang="pug">
section(style='margin-top: 15px')
    h4(style='font-weight: bold; color: #3b3b3b') {{ $t('mensagens.territorio.territorioAr.informacao') }}
    el-form(
        label-position='top',
        :model='form',
        :rules='rules',
        ref='ruleForm'
    )
        el-row(
            align='bottom',
            justify='space-between',
            type='flex',
            :gutter='20'
        )
            el-col(:span='8')
                el-form-item(
                    style='width: 100%',
                    prop='idCultura',
                    :label='$t("mensagens.territorio.territorioAr.cultivo")'
                )
                    el-select(
                        style='width: 100%',
                        :placeholder='$t("mensagens.comuns.selecione")',
                        v-model='form.idCultura'
                    )
                        el-option(
                            :value='item.id',
                            :label='item.nomeTraduzido',
                            :key='item.id',
                            v-for='(item, index) in cultivos'
                        )
            el-col(:span='8')
                el-form-item(
                    prop='area',
                    :label='$t("mensagens.territorio.territorioAr.area")'
                )
                    el-input-number(
                        v-model.number='form.area',
                        :controls='false',
                        style='width: 100%'
                    )
            el-col(:span='8')
                el-button(
                    @click='addInformation("ruleForm")',
                    style='margin-bottom: 8px',
                    type='primary',
                    icon='el-icon-circle-plus-outline'
                )
    el-divider
    div(v-if='options.length > 0')
        el-row.list(
            type='flex',
            :key='index',
            v-for='(item, index) in options'
        )
            el-col
                label
                    | {{
                    |
                    | $t('mensagens.territorio.territorioAr.cultivo')
                    |
                    | }}
                dl {{ nameCultivo(item.idCultura) }}
            el-col
                label
                    | {{
                    |
                    | $t('mensagens.territorio.territorioAr.area')
                    |
                    | }}
                dl {{ item.area }}
            el-col(:span='1')
                el-button(
                    @click='deleteInformation(index)',
                    style='margin: 0px 16px; color: #dc362e',
                    type='text',
                    icon='el-icon-delete'
                )
    div(v-else='')
        h4.text-center {{ $t('mensagens.territorio.territorioAr.mensagem') }}
</template>
<script>
export default {
    data() {
        return {
            form: { idCultura: '', area: '', media: 0 },
            rules: {
                idCultura: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: 'blur'
                    }
                ],
                area: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: 'change'
                    },
                    { type: 'number', message: 'age must be a number' }
                ],
                media: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: 'change'
                    },
                    { type: 'number', message: 'age must be a number' }
                ]
            }
        };
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        cultivos: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        nameCultivo(id) {
            if (typeof id === 'number') {
                return this.cultivos.find(item => item.id === id)
                    ?.nomeTraduzido;
            } else {
                return id;
            }
        },
        addInformation(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    const params = this.form;

                    this.$emit('update', params);
                    this.form = {
                        idCultura: '',
                        area: '',
                        media: ''
                    };
                } else {
                    return false;
                }
            });
        },
        deleteInformation(index) {
            this.$emit('delete', index);
        }
    }
};
</script>
<style scoped lang="scss">
.list {
    text-align: left;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 5px 15px;

    label {
        color: #183b57;
        font-weight: 500;
    }

    dl {
        color: #3b3b3b;
        font-weight: 600;
        margin-bottom: 0px !important;
    }
}
</style>
